import { FC } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import { routes } from 'src/constants/routes';
import { BookingSummaryPage } from 'src/pages/booking-summary';
import { BookingDetailsPage } from 'src/pages/booking-details';
import { OccupantDetailsPage } from 'src/pages/occupant-details';
import { SuccessPage } from 'src/pages/success';
import { HosSuccessPage } from 'src/pages/hos-sucess';
import { FailurePage } from 'src/pages/failure';
import { AbortedPage } from 'src/pages/aborted';
import { CallbackPage, DualOccupantCallbackPage } from 'src/pages/callback';
import { SetPasswordPage } from 'src/pages/set-password';
import { ProcessingAmendPage, ProcessingPage } from 'src/pages/processing';
import { LogoutCallbackPage } from 'src/pages/logout';
import { RoomNotAvailable } from 'src/pages/room-not-available';
import { BrochureCallbackPage } from 'src/pages/brochure-callback/brochure-callback';
import { NoRoomSelected } from 'src/pages/no-room-selected/no-room-seleted';
import { getTheme } from 'src/utils/getTheme';
import { AmendBookingDualOccupantWrapper, AmendBookingWrapper } from 'src/pages/amend';
import { BookingUpdatedPage } from 'src/pages/booking-updated';
import { BookingUpdateFailurePage } from 'src/pages/booking-update-failure';
import { BookingUpdateExpiredPage } from 'src/pages/booking-update-expired';
import { NotFoundPage } from 'src/pages/not-found';
import { MakeAPaymentPage } from 'src/pages/make-a-payment';
import { PaymentSuccessfulPage } from 'src/pages/paymentSuccessful';

const { isHosTheme } = getTheme();

export const Routing: FC = () => (
    <Routes>
        <Route path="*" element={<Navigate to={routes.notFound.index} />} />
        <Route path={routes.index} element={<Navigate to={routes.summary.index} />} />
        <Route path={routes.summary.index} element={<BookingSummaryPage />} />
        <Route path={routes.bookingDetails.index} element={<BookingDetailsPage />} />
        <Route path={routes.occupant.createPassword} element={<SetPasswordPage />} />
        <Route path={routes.occupant.details} element={<OccupantDetailsPage />} />
        <Route
            path={routes.success.index}
            element={isHosTheme ? <HosSuccessPage /> : <SuccessPage />}
        />
        <Route path={routes.paymentSuccessful.index} element={<PaymentSuccessfulPage />} />
        <Route path={routes.failure.index} element={<FailurePage />} />
        <Route path={routes.aborted.index} element={<AbortedPage />} />
        <Route path={routes.callback.index} element={<CallbackPage />} />
        <Route path={routes.brochureCallback.index} element={<BrochureCallbackPage />} />
        <Route path={routes.callback.additionalOccupant} element={<DualOccupantCallbackPage />} />
        <Route path={routes.callback.amendBooking} element={<CallbackPage isAmendCallback />} />
        <Route
            path={routes.callback.amendBookingDualOccupant}
            element={<CallbackPage isDualOccupantAmendCallback />}
        />
        <Route path={routes.amendBooking.index} element={<AmendBookingWrapper />} />
        <Route
            path={routes.amendBooking.dualOccupant}
            element={<AmendBookingDualOccupantWrapper />}
        />
        <Route path={routes.processing.index} element={<ProcessingPage />} />
        <Route path={routes.processing.amend} element={<ProcessingAmendPage />} />
        <Route path={routes.logoutCallback.index} element={<LogoutCallbackPage />} />
        <Route path={routes.roomNotAvailable.index} element={<RoomNotAvailable />} />
        <Route path={routes.noRoomSelected.index} element={<NoRoomSelected />} />
        <Route path={routes.bookingUpdated.index} element={<BookingUpdatedPage />} />
        <Route path={routes.failure.update} element={<BookingUpdateFailurePage />} />
        <Route path={routes.bookingUpdateExpired.index} element={<BookingUpdateExpiredPage />} />
        <Route path={routes.notFound.index} element={<NotFoundPage />} />
        <Route path={routes.makeAPayment.index} element={<MakeAPaymentPage />} />
    </Routes>
);
